module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Zurzach_COA-10c0f9ca20989d7764eb62cc60272642.svg";